<ngx-spinner [fullScreen]="false" type="pacman" [name]="spinnerName" bdColor="rgba(51,51,51,0.3)"></ngx-spinner>

<mat-tab-group mat-align-tabs="start" class="ap-tabs" [selectedIndex]="selectedTabIndex">

  <!-- Zakładka: Podgląd aneksu (PDF) -->
  @if (!details?.Annex?.IsImported) {
    <mat-tab [label]="'AnnexRegistry.ShowAnnexDetails' | translate">
      <app-annex-file-panel [annexId]="annexId" class="ap-pdf-tab"></app-annex-file-panel>
    </mat-tab>
  }

  <!-- Zakładka: Szczegóły aneksu -->
  <mat-tab [label]="'AnnexPanel.SectionChanges' | translate">
    <div class="ap-container">
      @if (details) {

  <!-- Dane podstawowe -->
  <div class="content-card">
    <h2 class="content-card__header">{{ 'AnnexPanel.SectionBasic' | translate }}</h2>
    <table>
      <tbody>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.Worker' | translate }}</td>
          <td class="key-value-row__value"><strong>{{ details.WorkerAgreement.FullName }}</strong></td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.EmploymentType' | translate }}</td>
          <td class="key-value-row__value">{{ details.WorkerAgreement.EmploymentType }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.AgreementConclusionDate' | translate }}</td>
          <td class="key-value-row__value">{{ details.WorkerAgreement.ConclusionDate | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.DateFrom' | translate }}</td>
          <td class="key-value-row__value">{{ details.WorkerAgreement.EmploymentDateFrom | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.DateTo' | translate }}</td>
          <td class="key-value-row__value">
            {{ details.WorkerAgreement.EmploymentDateTo ? (details.WorkerAgreement.EmploymentDateTo | date: 'yyyy-MM-dd') : '—' }}
          </td>
        </tr>
        @if (details.WorkerAgreement?.AgreementNumber) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.AgreementNumber' | translate }}</td>
          <td class="key-value-row__value">{{ details.WorkerAgreement.AgreementNumber }}</td>
        </tr>
        }
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.AnnexOrdinalNumber' | translate }}</td>
          <td class="key-value-row__value"><strong>{{ 'AnnexPanel.AnnexNumber' | translate: { number: details.Annex.AnnexNumber } }}</strong></td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.ConclusionDate' | translate }}</td>
          <td class="key-value-row__value">{{ details.Annex.AnnexConclusionDate | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexRegistry.StartDateFrom' | translate }}</td>
          <td class="key-value-row__value">{{ details.Annex.AnnexStartDate | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexRegistry.EndDateTo' | translate }}</td>
          <td class="key-value-row__value">
            {{ details.Annex.AnnexEndDate ? (details.Annex.AnnexEndDate | date: 'yyyy-MM-dd') : '—' }}
          </td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.Status' | translate }}</td>
          <td class="key-value-row__value">
              <div class="label" [ngClass]="getStatusClass(details.Annex.AnnexStatusId)">
                <span class="label__dot"></span>
                <span class="label__name">{{ details.Annex.AnnexStatus }}</span>
              </div>
              @if (isAdmin && details.Annex.IsConsistent === false) {
              <span class="ap-inconsistent" [matTooltip]="'AnnexPanel.Inconsistent' | translate">!</span>
            }
            <app-annex-imported-badge [visible]="details.Annex.IsImported" />
          </td>
        </tr>
        @if (isAdmin) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AnnexPanel.ImportStatus' | translate }}</td>
          <td class="key-value-row__value">
            @if (details.Annex.AnnexSyncStatusId && !details.Annex.IsImported) {
              <div class="label" [ngClass]="getExternalSyncStatusClass(details.Annex.AnnexSyncStatusId)">
                <span class="label__dot"></span>
                <span class="label__name">{{ details.Annex.AnnexSyncStatusName }}</span>
              </div>
            } @else {
              <span class="ap-empty-value">—</span>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Zmieniane dane -->
  <div class="content-card">
    <h2 class="content-card__header">{{ 'AnnexPanel.SectionChanges' | translate }}</h2>
    @if (details.Annex.ChangesJobTitle || details.Annex.ChangesWage || details.Annex.ChangesSupervisor || details.Annex.ChangesTemporaryWorkplace || details.Annex.ChangesWorkingTimeGroup) {
    <table class="changes-table">
      <thead>
        <tr>
          <th></th>
          <th class="col-before">{{ 'AnnexPanel.Before' | translate }}</th>
          <th>{{ 'AnnexPanel.After' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @if (details.Annex.ChangesWage && details.Annex.Wages?.length) {
        @for (wage of details.Annex.Wages; track wage.WageTypeName) {
        <tr>
          <td class="field-name">{{ 'AnnexPanel.Wages' | translate }}</td>
          <td class="col-before">{{ getBeforeWage(wage.WageTypeName) }}</td>
          <td><strong>{{ wage.Value | number: '1.2-2' }} {{ wage.CurrencyName }}</strong></td>
        </tr>
        <tr>
          <td class="field-name">{{ 'AnnexPanel.WageType' | translate }}</td>
          <td class="col-before">{{ getBeforeWageType(wage.WageTypeName) }}</td>
          <td><strong>{{ wage.WageTypeName }}</strong></td>
        </tr>
        }
        }
        @if (details.Annex.ChangesWorkingTimeGroup) {
        <tr>
          <td class="field-name">{{ 'WorkingTimeGroup' | translate }}</td>
          <td class="col-before">{{ details.WorkerAgreement.WorkingTimeGroupName }}</td>
          <td><strong>{{ details.Annex.WorkingTimeGroupName }}</strong></td>
        </tr>
        }
        @if (details.Annex.ChangesJobTitle) {
        <tr>
          <td class="field-name">{{ 'JobTitle' | translate }}</td>
          <td class="col-before">{{ details.WorkerAgreement.JobTitleName }}</td>
          <td><strong>{{ details.Annex.JobTitleName }}</strong></td>
        </tr>
        @if (details.Annex.OrganizationalUnitName) {
        <tr>
          <td class="field-name">{{ 'OrganizationalUnit' | translate }}</td>
          <td class="col-before">{{ details.WorkerAgreement.OrganizationalUnitName }}</td>
          <td><strong>{{ details.Annex.OrganizationalUnitName }}</strong></td>
        </tr>
        }
        }
        @if (details.Annex.ChangesTemporaryWorkplace) {
        <tr>
          <td class="field-name">{{ 'TemporaryWorkplace' | translate }}</td>
          <td class="col-before">{{ details.WorkerAgreement.TemporaryWorkplaceName }}</td>
          <td><strong>{{ details.Annex.TemporaryWorkplaceName }}</strong></td>
        </tr>
        }
        @if (details.Annex.ChangesSupervisor) {
        <tr>
          <td class="field-name">{{ 'Supervisor' | translate }}</td>
          <td class="col-before">{{ details.WorkerAgreement.PotentialSupervisorName }}</td>
          <td><strong>{{ details.Annex.PotentialSupervisorName }}</strong></td>
        </tr>
        }
      </tbody>
    </table>
    } @else {
    <p class="no-changes">{{ 'AnnexPanel.NoChanges' | translate }}</p>
    }
  </div>
    }
    </div>
  </mat-tab>

</mat-tab-group>
